export function isValidAccountNumber(accountNumberElement) {
    let isValid = false;
    if (accountNumberElement.value == "") {
        isValid = false;
    }
    else {
        isValid = accountNumberElement.checkValidity();
    }
    return isValid;
}
export function isValidPin(pinElement) {
    return !pinElement.validity.valueMissing && !pinElement.validity.patternMismatch;
}
//# sourceMappingURL=validators.js.map